export enum ResetPasswordState
{
    inputUserForm,
    newPasswordForm,
    resetRequestSent,
    completeAndSuccessful,
    feedbackMessage
}
